import PropTypes from 'prop-types';
import React from 'react';
import FiltersContainer from '../Filters/FiltersContainer';

const PageHeader = ({
    handleProductTypeSelect,
    fairCartProducts,
    selectedProductType,
    selectedSuppliers,
    suppliers,
    searchTerm,
    handleSelectSuppliers,
    handleSearch,
}) => (
    <div className="page-header">
        <div className="page-header__boxes">
            <FiltersContainer
                handleProductTypeSelect={handleProductTypeSelect}
                fairCartProducts={fairCartProducts}
                selectedProductType={selectedProductType}
                selectedSuppliers={selectedSuppliers}
                suppliers={suppliers}
                searchTerm={searchTerm}
                handleSelectSuppliers={handleSelectSuppliers}
                handleSearch={handleSearch}
            />
        </div>
    </div>
);

PageHeader.propTypes = {
    handleProductTypeSelect: PropTypes.func,
    fairCartProducts: PropTypes.object,
    selectedProductType: PropTypes.string,
    selectedSuppliers: PropTypes.arrayOf(PropTypes.string),
    suppliers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            description: PropTypes.string,
        })
    ),
    searchTerm: PropTypes.string,
    handleSelectSuppliers: PropTypes.func,
    handleSearch: PropTypes.func,
};

export default PageHeader;
